<template>
  <el-dialog
    v-model="visible"
    width="85%"
    align-center
    class="CreateChannel_model"
    draggable
    :before-close="Cancel"
  >
    <template #header>
      <div class="header">
        <h4>{{ $t("slack.Create_a_channel") }}</h4>
      </div>
    </template>
    <div class="modal_content">
      <p class="text">{{ $t("slack.Channelname") }}</p>
      <div class="inputBox">
        <el-input
          v-model="Channelname"
          :placeholder="ChannelnameText"
          maxlength="20"
          show-word-limit
        />
      </div>
      <p class="text">{{ $t("slack.description") }}</p>
      <div class="inputBox" style="margin-bottom: 7px">
        <el-input
          v-model="description"
          type="textarea"
          :rows="4"
          :placeholder="descriptionText"
          maxlength="20"
          show-word-limit
        />
      </div>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="Cancel">{{ $t("slack.Cancel") }}</el-button>
        <el-button type="primary" @click="Confirm" :disabled="disabledBtn">
          {{
          $t("slack.Confirm")
          }}
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import * as $axios from "../api/index";
import { HomeStore } from "../index";
import { debounce } from "../utils/index";
import { ElMessage, ElMessageBox } from "element-plus";
import { useDemoStore } from "@/pinia/index.js";
export default {
  data() {
    return {
      Channelname: "",
      description: "",
      userID: "",
      visible: false,
      disabledBtn: false,
      ChannelnameText:
        useDemoStore().lang == "en-us"
          ? "Please enter the Channel Name"
          : "请输入频道名称",
      descriptionText:
        useDemoStore().lang == "en-us"
          ? "Please enter the description"
          : "请输入描述",
    };
  },
  computed: {
    isCreateChannel() {
      return HomeStore().setting.isCreateChannel;
    },
    allusers() {
      return HomeStore().allusers;
    },
    token() {
      return HomeStore().token;
    },
  },
  watch: {
    isCreateChannel(val) {
      this.visible = val;
      this.Channelname = "";
      this.description = "";
    },
  },
  created() {},
  methods: {
    Cancel() {
      if (this.Channelname.trim() || this.description.trim()) {
        if (useDemoStore().lang == "en-us") {
          ElMessageBox.confirm(
            "Edited information not been saved yet. Are you sure to leave?",
            "Warning",
            {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              type: "warning",
            }
          )
            .then(() => {
              HomeStore().setConfig("isCreateChannel", false);
            })
            .catch(() => {});
        }
        if (useDemoStore().lang == "zh-cn") {
          ElMessageBox.confirm(
            "已编辑的信息尚未保存。你确定要离开吗?",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          )
            .then(() => {
              HomeStore().setConfig("isCreateChannel", false);
            })
            .catch(() => {});
        }
      } else {
        HomeStore().setConfig("isCreateChannel", false);
      }
    },
    Confirm: debounce(function () {
      if (this.Channelname.trim() == "") {
        if (useDemoStore().lang == "en-us") {
          ElMessage({
            type: "info",
            message: "Please enter the Channel Name",
          });
        } else {
          ElMessage({
            type: "info",
            message: "请输入频道名称",
          });
        }
        return;
      }
      this.disabledBtn = true;
      $axios
        .creategroup({
          token: this.token,
          group_name: this.Channelname,
          description: this.description,
        })
        .then((res) => {
          if (useDemoStore().lang == "en-us") {
            ElMessage({
              type: "success",
              message: "success",
            });
          } else {
            ElMessage({
              type: "success",
              message: "成功",
            });
          }
          HomeStore().IsPrivatechat = {
            group_id: res.data.id,
          };
          HomeStore().chatMessageList[res.data.id] = [];
          HomeStore().isNeedQuery[res.data.id] = true;
          res.data.group_id = res.data.id;
          HomeStore().channelList.unshift(res.data);
          HomeStore().setConfig("isCreateChannel", false);
          this.disabledBtn = false;
        })
        .finally(() => {});
    }, 500),
  },
};
</script>
<style lang="less">
.CreateChannel_model {
  .header {
    h4 {
      font-size: 18px;
      font-weight: 900;
    }
  }
  .el-dialog__headerbtn {
    top: 7px !important;
  }
  .el-dialog__header {
    padding-bottom: 0 !important;
  }
  .el-dialog__body {
    .modal_content {
      .text {
        margin-top: 15px;
        font-size: 15px;
        font-weight: 700;
        color: #000000;
      }
      .inputBox {
        margin-top: 15px;
        .el-select {
          width: 100%;
        }
      }
      .hintText {
        color: rgba(var(--sk_foreground_max_solid, 97, 96, 97), 1);
        font-size: 13px;
        font-weight: 400;
        line-height: 1.38461538;
        margin-top: 4px;
        margin-bottom: 7px;
      }
    }
  }
}
</style>
